export const USAGE_REQUEST = "USAGE_REQUEST";
export const USAGE_SUCCESS = "USAGE_SUCCESS";
export const USAGE_FAIL = "USAGE_FAIL";
